import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  visible: boolean;
    dashboard: boolean;
    admin:boolean;

  constructor() { this.visible = false; this.dashboard =false ; this.admin = false;}

  hide() { this.visible = false; }

  show() { this.visible = true; }

  toggle() { this.visible = !this.visible; }

  doSomethingElseUseful() { }


  dhide() { this.dashboard = false; }

  dshow() { this.dashboard = true; }

  dtoggle() { this.dashboard = !this.visible; }

  ddoSomethingElseUseful() { }


  adhide() { this.admin = false; }

  adshow() { this.admin = true; }

  adtoggle() { this.admin = !this.visible; }

  addoSomethingElseUseful() { }

 
}